import React from "react";
import { cn } from "src/helpers";
import MultiFileUpload from "./MultiFileUpload";

import { ClassNameValue } from "tailwind-merge";

type Props = {
  formik: any;
  label: string;
  nameKey: string;
  required?: boolean;
  disabled?: boolean;
  value?: any[];
  onChange?: (e: any) => void;
  labelStyle?: ClassNameValue;
  error_className?: ClassNameValue;
};

const FormikMUltiFIleUpload = ({
  formik,
  label,
  nameKey,
  required,
  disabled,
  value,
  onChange,
  labelStyle,
  error_className,
}: Props) => {
  return (
    <>
      <div className="mt-2">
        <MultiFileUpload
          label={label}
          required={required}
          labelStyle={labelStyle}
          value={formik.values[nameKey] || value || []}
          onChange={(e: any) => {
            onChange && onChange(e);
          }}
        />
      </div>
      {formik.touched[nameKey] && formik.errors[nameKey] && (
        <div className={cn("text-xs font-medium text-destructive", error_className)}>{formik.errors[nameKey]}</div>
      )}
    </>
  );
};

export default FormikMUltiFIleUpload;
